const applyMask = () => {
  const Mask = window.storeTheme.helpers.inputMask;  
  const inputCelular = document.querySelector('#inputTel');
  const inputCNPJ = document.querySelector('#inputCnpj');
  inputCelular.setAttribute('data-mask', '(99) 9 9999-9999');
  inputCNPJ.setAttribute('data-mask', '99.999.999/9999-99');

  const els = [inputCelular, inputCNPJ];
  for (const el of els) {
      new Mask(el, { init: true });
  }
};

applyMask();

const $form = $('#form-swift');
const formObj = {};
const formDataObj = {};
const formSubmit = async (e: Event) => {
    e.preventDefault();
    e.stopPropagation();
    $form.find('.message--form.error').addClass('d-none');
    $form.find('.form-group input').map((i, el) => {
        const type = el.type;
        const value = el.value;
        const name = el.name;
        formObj[`${name}`] = {
        type: type,
        value: value,
        };
    });
    await validateInputs(formObj, sendData);
};
  
$form.on('submit', formSubmit);
  
const validateInputs = async (formObj: Object, callback: any) => {
    try {
    Object.entries(formObj).forEach((value) => {
        if (value[0] === 'cnpj') {
        const cnpjRegex = /^\d{2}\.\d{3}\.\d{3}\/\d{4}\-\d{2}$/;
        const cnpjIsOk = value[1].value.match(cnpjRegex);
        const cnpjIsValid = cnpjValidation(value[1].value);
        if (!cnpjIsOk || !cnpjIsValid) {
            showError('O CNPJ informado não é válido.');
            throw 'Break';
        }
        }
        formatData(value);
    });
    } catch (error) {
    if (error !== 'Break') throw error;
    }

    await callback(formDataObj, 'FE', window.jsnomeLoja);
};
  
const showError = (message: string) => {
    $form.find('.message--form.error').html(message);
    $form.find('.message--form.error').addClass('mb-0');
    $form.find('.message--form.error').parent().addClass('mt-3');
    $form.find('.message--form.error').removeClass('d-none');
};

const formatData = (inputValue: [string, { type: string; value: string | boolean }]) => {
    let [key, value] = inputValue; 
    formDataObj[key] = value.value;
};

const sendData = async (formObj: Object, entity_sigla: string, seller) => {
  const masterDataAPI = window.storeTheme.helpers.vtexMasterdata({ entity_sigla, seller });
  const res: Object = await masterDataAPI.post(formObj);
  if (res.hasOwnProperty('Id') && res['Id'] !== '') {
    $form.find('.message--form.sucess').removeClass('d-none');
    loadAndRefresh();
  }
};

const loadAndRefresh = () => {
  const oldBtnSendForm = $form.find('.rnk-form-button').html();
  const loader = window.storeTheme.helpers.loader.getHtmlLoader();
  $form.find('.rnk-form-button').html(loader);
  setTimeout(() => {
    $form.find('.rnk-form-button').html(oldBtnSendForm);
    $('#form-swift').on('submit', formSubmit);
    document.location.reload();
  }, 2600);
};

const cnpjValidation = (value) => { 
    if (!value) return false
    const isString = typeof value === 'string'
    const validTypes = isString || Number.isInteger(value) || Array.isArray(value)
    // Elimina inválido
    if (!validTypes) return false
    if (isString) {
        // limita caracteres formatado
        if (value.length > 18) return false
        const digitsOnly = /^\d{14}$/.test(value)
        const validFormat = /^\d{2}.\d{3}.\d{3}\/\d{4}-\d{2}$/.test(value)
        if (digitsOnly || validFormat) true
        else return false
    }
    
    const match = value.toString().match(/\d/g)
    const numbers = Array.isArray(match) ? match.map(Number) : []
    if (numbers.length !== 14) return false
    const items = [...new Set(numbers)]
    if (items.length === 1) return false
    const calc = (x) => {
        const slice = numbers.slice(0, x)
        let factor = x - 7
        let sum = 0
        for (let i = x; i >= 1; i--) {
            const n = slice[x - i]
            sum += n * factor--
            if (factor < 2) factor = 9
        }
        const result = 11 - (sum % 11)
        return result > 9 ? 0 : result
    }
    const digits = numbers.slice(12)
    const digit0 = calc(12)
    if (digit0 !== digits[0]) return false
    const digit1 = calc(13)
    return digit1 === digits[1]
}

export default {}